/*
 * Tiny dependency-free SVG line chart for wellness progress.
 * `points` = [{ date: 'YYYY-MM-DD', value: number }] in ascending date order.
 */
export default function MiniChart({ points = [], unit = '', height = 120 }) {
  if (points.length === 0) return null

  const W = 320
  const H = height
  const padX = 10
  const padY = 16
  const values = points.map((p) => p.value)
  let min = Math.min(...values)
  let max = Math.max(...values)
  if (min === max) { min -= 1; max += 1 } // flat line — give it room
  const range = max - min

  const x = (i) => padX + (points.length === 1 ? (W - 2 * padX) / 2 : (i * (W - 2 * padX)) / (points.length - 1))
  const y = (v) => padY + (1 - (v - min) / range) * (H - 2 * padY)

  const line = points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${x(i).toFixed(1)} ${y(p.value).toFixed(1)}`).join(' ')
  const area = `${line} L ${x(points.length - 1).toFixed(1)} ${H - padY} L ${x(0).toFixed(1)} ${H - padY} Z`

  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" role="img" aria-label="Progress chart">
      <defs>
        <linearGradient id="wlFill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="var(--accent)" stopOpacity="0.28" />
          <stop offset="1" stopColor="var(--accent)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill="url(#wlFill)" />
      <path d={line} fill="none" stroke="var(--accent)" strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />
      {points.map((p, i) => (
        <circle key={i} cx={x(i)} cy={y(p.value)} r={i === points.length - 1 ? 4 : 2.5}
          fill={i === points.length - 1 ? 'var(--primary)' : 'var(--surface)'} stroke="var(--accent)" strokeWidth="1.5" />
      ))}
      <text x={x(points.length - 1)} y={Math.max(y(points[points.length - 1].value) - 8, 12)} textAnchor="end"
        fontSize="12" fontWeight="700" fill="var(--text)">
        {points[points.length - 1].value}{unit}
      </text>
    </svg>
  )
}
